import Sentry from "@similarweb/sentry-logger";

import type { BenchmarkDataType } from "app/pages/benchmark-tracker/types/api.types";
import { isResourceNotFoundError, type IFetchService } from "app/services/fetchService";

import { BENCHMARK_USER_API } from "./constants";

type BenchmarkApiServiceEntity = {
    getBenchmarkById(benchmarkId: string): Promise<BenchmarkDataType | null>;
};

export const benchmarkApiService = (fetchService: IFetchService): BenchmarkApiServiceEntity => ({
    getBenchmarkById: async (benchmarkId: string): Promise<BenchmarkDataType | null> => {
        try {
            return await fetchService.get(`${BENCHMARK_USER_API}/${benchmarkId}`);
        } catch (error) {
            const isNotFound = isResourceNotFoundError(error);

            Sentry.errorTracker({
                e: error,
                message: "Benchmarks - error when fetching benchmark by id",
                level: isNotFound ? "warning" : "error",
                params: { extra: { benchmarkId } },
            });
            return null;
        }
    },
});
